import { Dtos } from "@inrev/common";
import { Option } from "@inrev/core";

type AccountData = Dtos.SuretyAccount.Get.Response;

export const checkWip = (
	latestWipStatement: Option<Dtos.WipStatement.Get.Response>,
	modelSize: AccountData["modelSize"],
): { label: string } | null => {
	if (Option.isNone(latestWipStatement)) {
		return { label: "WIP" };
	}

	if (Option.isNone(latestWipStatement.projectBacklogCost)) {
		return { label: "WIP" };
	}

	if (modelSize === "large" && Option.isNone(latestWipStatement.projectBacklogGrossProfit)) {
		return { label: "WIP" };
	}

	return null;
};
